import * as React from 'react';
import {ImageBaseUrl} from '../Constants';
import {HashLink as Link} from 'react-router-hash-link';
import {allPages} from "../data";

export const Home: React.FC = () => (
    <div id='homepage'>
        {allPages.map((page) => (
            <div className='topic'>
                <img className='topic-img'
                     src={ImageBaseUrl + page.image}
                     alt={page.name}/>

                <Link to={'/' + page.path}>
                    <h2>{page.name}</h2>
                </Link>

                {page.elements.map(item => (
                    <Link to={'/' + page.path + '#' + item.anchor}>{item.name}</Link>
                ))}
            </div>
        ))}
    </div>
);
